import Entries from '@Services/Entries';

export default function useCurrentPageSize({ pageNumber }, activeBreadcrumb) {
  if (!activeBreadcrumb) {
    return undefined;
  }

  const resultSize = activeBreadcrumb.totalResult;
  const resultsPerPage = Entries.limit;

  if (resultSize < resultsPerPage) {
    return resultSize;
  }

  if (resultSize < resultsPerPage * pageNumber) {
    return resultsPerPage - (resultsPerPage * pageNumber - resultSize);
  }

  return resultsPerPage;
}
